"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.Error = exports.InputContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _widths = require("../../../../styles/widths");

var _palette = require("../../../../styles/palette");

var _index = _interopRequireDefault(require("../../Icon/index"));

var _templateObject, _templateObject2, _templateObject3;

var InputContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  max-width: ", ";\n  min-height: ", "px;\n  margin-bottom: ", "px;\n  margin-top: ", "px;\n  & label {\n    position: relative;\n    line-height: 22px;\n    left: ", ";\n    top: ", ";\n    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    z-index: 1;\n    pointer-events: none;\n    user-select: none;\n    font-size: ", "px;\n    color: ", ";\n    font-weight: ", ";\n  }\n  & input {\n    position: relative;\n    background-color: transparent;\n    border: none;\n    border-radius: 0;\n    border-bottom: ", ";\n    left: 0;\n    bottom: 0;\n    font-size: 16px;\n    font-weight: ", ";\n    line-height: 22px;\n    padding-bottom: 7px;\n    width: ", ";\n    padding-left: ", "px;\n    transition: border-bottom 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    &:focus {\n      outline: none;\n    }\n  }\n  & span {\n    margin-top: 8px;\n    z-index: 1;\n    line-height: 16px;\n    color: ", ";\n    font-size: 12px;\n  }\n"])), function (props) {
  return props.width ? typeof props.width === 'string' ? props.width : "".concat(props.width, "px") : "".concat(_widths.widths.base * 40, "px");
}, _widths.widths.base * 7, _widths.widths.base, _widths.widths.base, function (props) {
  return props['data-active'] || props.dirty ? props.icon ? '-22px' : 0 : props.icon ? "".concat(_widths.widths.base * 1.5, "px") : 0;
}, function (props) {
  return props['data-active'] || props.dirty ? props.icon ? '3px' : 0 : props.icon ? '30px' : '25px';
}, function (props) {
  return props['data-active'] || props.dirty ? 12 : 16;
}, function (props) {
  return props.error ? _palette.palette.error : props['data-active'] ? _palette.palette.link : _palette.palette.bobBlack;
}, _widths.font.regular, function (props) {
  return props.error ? "solid 2px ".concat(_palette.palette.error) : props['data-active'] ? "solid 2px ".concat(_palette.palette.link) : "solid 1px ".concat(_palette.palette.bobBlack);
}, _widths.font.regular, function (props) {
  return props.icon ? "calc(100% - ".concat(_widths.widths.base * 4, "px)") : '100%';
}, function (props) {
  return props.icon ? _widths.widths.base * 4 : 0;
}, function (props) {
  return props.error ? _palette.palette.error : _palette.palette.grey;
});

exports.InputContainer = InputContainer;
InputContainer.displayName = 'InputContainer';

var Error = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n"])), _palette.palette.error);

exports.Error = Error;
Error.displayName = 'Error';
var StyledIcon = (0, _styledComponents["default"])(_index["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  float: left;\n  position: relative;\n  top: 27px;\n"])));
exports.StyledIcon = StyledIcon;
StyledIcon.displayName = 'StyledIcon';